import styled from 'styled-components';
import { CustomCheckbox } from '../../../ui/atoms/Checkbox/style';
import { InputContainer } from '../../../ui/atoms/CustomInput/style';

export const FormContainer = styled.div`
  max-width: min-content;

  .title {
    min-width: min(382px, calc(var(--full-width) - 20px));
    max-width: var(--full-width) !important;
    letter-spacing: -0.2px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    min-width: 100%;
  }
`;

export const Image = styled.img`
  margin-bottom: 60px;
`;

export const InputWrapper = styled.div`
  margin-top: 20px;
  margin-right: auto;
  margin-left: auto;
  width: 380px;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }

  &.btns-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    button {
      margin: 0;
    }
  }
`;

export const UsernameWrapper = styled.div`
  position: relative;

  //the tooltip
  [data-tooltip-id] {
    position: absolute;
    top: calc((38px / 2) - (24px / 2)); //input height - tooltip icon height
    left: calc(100% + 16px);
  }
`;

export const PasswordWrapper = styled.div`
  position: relative;

  //the show/hide icon
  button {
    position: absolute;
    top: calc((40px / 2) - (24px / 2)); //input height - tooltip icon height
    left: calc(100% + 16px);
  }

  @media ${(props) => props.theme.device.mobileL} {
    ${InputContainer} {
      padding-right: calc(10px + 24px + 10px);
    }

    //the show/hide icon
    button {
      left: auto;
      right: 10px;
    }
  }
`;

export const LogoContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  text-align: center;
`;

export const Title = styled.div`
  font-size: 32px;
  font-weight: bold;
  max-width: 380px;
  margin: auto;

  @media ${(props) => props.theme.device.tabletL} {
    max-width: 100%;
    position: inherit;
    margin-bottom: 10px;
  }
`;

export const Subtitle = styled.div`
  max-width: 380px;
  margin: auto;
  line-height: 1.4;
  margin-bottom: 40px;

  @media ${(props) => props.theme.device.tabletL} {
    max-width: 100%;
    position: inherit;
    margin-bottom: 20px;
  }
`;

export const ResetPassword = styled.div`
  cursor: pointer;
  margin-top: 8px;
  color: ${(props) => props.theme.colors.link};
`;

export const WelcomeWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const AuthContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textPrimary};
  width: var(--full-width);
  flex-direction: column;
  align-items: center;
  padding: 56px 0;

  @media ${(props) => props.theme.device.mobileL} {
    padding: 40px 0;
  }

  button {
    margin: auto;
  }

  .contacts a {
    font-weight: 400;
  }
`;

export const ProvidersWrapper = styled.div`
  position: absolute;
  bottom: 80px;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textPrimary};
  border-radius: 4px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  max-height: 60vh;
  overflow-y: auto;
`;

export const Square = styled.div`
  position: absolute;
  bottom: 74px;
  left: 30px;
  transform: rotate(45deg);
  width: 12px;
  height: 12px;
  background-color: white;
  box-shadow: 2px 5px 2px rgba(0, 0, 0, 0.1), 5px 2px 2px rgba(0, 0, 0, 0.1),
    0 0 0 white, 0 0 0 white;
  z-index: 0;
`;

export const ProviderCard = styled.div`
  padding: 12px 20px;
  height: 80px;
  width: 380px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  cursor: pointer;

  h3 {
    color: ${(props) => props.theme.colors.link};
    line-height: 56px !important;
    text-align: center;
  }
`;

export const ProviderLogo = styled.div`
  height: 100%;
  width: auto;
  background: url(${({ src }) => src});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`;

export const CheckboxWrapper = styled.div`
  position: relative;
  margin-top: 24px;

  label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.black};

    a {
      color: ${(props) => props.theme.colors.link};
    }

    ${CustomCheckbox} {
      top: 3px;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const DisabledMessage = styled.p`
  margin-top: 24px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
